<dex-lp-details-standalone
    [lp]="lp()"
    [tranches]="tranches()"
    [isEmbedded]="true"
    [isCollapsed]="isCollapsed()"
    [isExpandCollapseEnabled]="true"
    [isSymbolClickable]="isSymbolClickable()"
    (toggleCollapsed)="toggleCollapsed.emit()"
    (symbolClick)="symbolClick.emit($event)">
</dex-lp-details-standalone>
